// extracted by mini-css-extract-plugin
export var markdown = "_s8-0";
export var tableWrapper = "_s8-1";